export const color = {
  nomeFantasiaColor: "#fff",
  razaoSocialColor: "#fff",
  cepColor: "#fff",
  enderecoColor: "#fff",
  numeroColor: "#fff",
  ufColor: "#fff",
  municipioColor: "#fff",
  bairroColor: "#fff",
  complementoColor: "#fff",
  telefone1Color: "#fff",
  telefone2Color: "#fff",
  emailColor: "#fff",
};

export const resetColor = () => {
  color.nomeFantasiaColor = "#ffffff";
  color.razaoSocialColor = "#ffffff";
  color.cepColor = "#ffffff";
  color.enderecoColor = "#ffffff";
  color.numeroColor = "#ffffff";
  color.ufColor = "#ffffff";
  color.municipioColor = "#ffffff";
  color.bairroColor = "#ffffff";
  color.complementoColor = "#ffffff";
  color.telefone1Color = "#ffffff";
  color.telefone2Color = "#ffffff";
  color.emailColor = "#ffffff";
};
